import React from 'react'

import DatasetDisclaimers from '../../components/EntityOverview/DatasetDisclaimers'
import DatasetExamples from '../../components/EntityOverview/DatasetExamples'
import DatasetTable from '../../components/EntityOverview/DatasetTable'
import EntityIntro from '../../components/EntityOverview/EntityIntro'
import { useFetchMetaData } from '../../hooks/useFetchMetaData'

const GridAreas = () => {
  const entity = 'grid-areas'
  const title = 'Grid areas'
  const metaData = useFetchMetaData(entity)

  if (!metaData) {
    return <div>Loading...</div>
  }

  return (
    <>
      <EntityIntro entity={entity} title={title} />
      <DatasetExamples entity={entity} />
      <DatasetTable datasets={metaData.data.attributes.datasets} entity={entity} />
      <DatasetDisclaimers entity={entity} />
    </>
  )
}

export default GridAreas
